import React from "react"
import tw, { styled } from "twin.macro"


const Heading = styled("h2")`
 ${tw` md:my-0 mb-3 font-bold text-primary-700 text-lg lg:text-lg lg:text-xl
 md:text-left `}
`
export default Heading
